module.exports = __webpack_public_path__ + "img/check_3.9c2037ee.png";